var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import datepicker from '../../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import datepickerNL from '../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.nl.min.js';

const app = {
    /** Initialize */
    init() {

        // Wrap breadcrumbs in container
        this.wrapBreadcrumbs();

        // Toggle Subnavigation
        this.toggleSubnavigation();

        // Initialize Sliders
        this.initSliders();

        this.initializeDatePickers();

        // Toggle video play
        this.videoPlayToggle();

        // Toggle Featured Items (accommodation detail)
        this.toggleFeaturedItems();

        // Show/Hide sticky booking form
        this.toggleStickyBookingForm();

        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger').on('click', $.proxy(this.toggleHamburgerMenu, this));
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $('.hamburger').toggleClass('is-active');
        $('body').toggleClass('is-locked');
        $(".navigation-items").toggleClass('is-visible');
    },

    /** Handles the scroll event */
    windowScrollHandler() {
        $('header').toggleClass('is-scrolled', $(window).scrollTop() > 0);
    },

    /** Toggle Subnavigation */
    toggleSubnavigation() {

        if ($(window).width() < 1024) {

            $('ul.navigation-list > li.has-children > a.navlink').click(function(e) {
                e.preventDefault();
                $(this).parent().toggleClass('is-opened').find('ul').slideToggle();
            });
        }
    },

    initSliders() {

        // Accommodation detail image carousel
        if ($('.section-accommodation-detail .image-carousel').length) {
            $('.section-accommodation-detail .image-carousel').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: true,
                dots: false,
                fade: false,
            });
        }

        if ($('.section-images-slider .slider').length) {
            $('.section-images-slider .slider').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                arrows: true,
                dots: false,
                fade: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
        }
    },

    wrapBreadcrumbs() {
        if ($('#breadcrumbs').length) {
            // $('#breadcrumbs span:nth-child(1)').wrap('<div class="container"></div>');
        }
    },

    initializeDatePickers() {

        function GetTodayDate() {
            var tdate = new Date();
            tdate.setDate(tdate.getDate() + 1);
            var dd = tdate.getDate(); //yields day
            var MM = tdate.getMonth(); //yields month
            var yyyy = tdate.getFullYear(); //yields year
            var currentDate = dd + "-" + (MM + 1) + "-" + yyyy;
            return currentDate;
        }

        $('.arrival-date').datepicker({
            autoclose: true,
            format: "yyyy-mm-dd",
            language: "nl",
            toggleActive: true,
            startDate: GetTodayDate(),
        });

        $('.departure-date').datepicker({
            autoclose: true,
            format: "yyyy-mm-dd",
            language: "nl",
            toggleActive: true,
            startDate: GetTodayDate(),
        });
    },

    videoPlayToggle() {
        $('.play-button').on('click', function () {
            // $(this).hide();

            $(this).parent().find('video').get(0).play();
        });
    },

    /** Toggle Featured Items (accommodation detail) */
    toggleFeaturedItems() {

        if ($(window).width() < 769) {

            let allFeaturedItems = $('.features .feature-item .feature-content').hide();

            $('.features .feature-item .feature-title').click(function() {
                let target = $(this).next();

                if(!target.hasClass('is-opened')) {
                    allFeaturedItems.removeClass('is-opened').slideUp();
                    $('.features .feature-item').removeClass('is-opened');
                    $(this).parent().closest('.feature-item').addClass('is-opened');
                    target.addClass('is-opened').slideDown();
                } else {
                    allFeaturedItems.removeClass('is-opened').slideUp();
                    $('.features .feature-item').removeClass('is-opened');
                    target.removeClass('is-opened').slideUp();
                }
                return false;
            });
        }
    },

    /** Show/Hide sticky booking form */
    toggleStickyBookingForm() {

        $(window).scroll(function() {
            var top_of_element = $("footer").offset().top;
            var bottom_of_element = $("footer").offset().top + $("footer").outerHeight();
            var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            var top_of_screen = $(window).scrollTop();

            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
                $(".sticky-booking-form").addClass("is-fixed");
            } else {
                $(".sticky-booking-form").removeClass("is-fixed");
            }
        });
    }
};
$(document).ready($.proxy(app.init, app));
